<template>
  <div class="home">
    <h4 class="sub-heading">
      Companies Commission
    </h4>
    <div class="row">
      <div class="form-group col-md-3 col-md-push-3">
        <label class="fs">Start Date</label>
        <date-picker
          v-model="start.date"
          format="yyyy-MM-dd"
          input-class="form-control bg-white"
        />
      </div>
      <div class="form-group col-md-3">
        <label class="fs">End Date</label>
        <date-picker
          v-model="to.date"
          format="yyyy-MM-dd"
          input-class="form-control bg-white"
        />
      </div>
    </div>
    <table
      ref="tb_companies"
      class="table table-striped table-responsive-sm"
    >
      <thead>
        <tr>
          <th>#</th>
          <th>Company</th>
          <th>CUR</th>
          <th>Amount</th>
          <th>Commission(KES)</th>
          <th>Bid Bonds</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, i) in companies"
          :key="i"
        >
          <td>{{ i + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.currency }}</td>
          <td>{{ $number.format(item.amount) }}</td>
          <td>{{ $number.format(item.commission) }}</td>
          <td>{{ $number.format(item.bidbond_count) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from 'jquery';
import DatePicker from "vuejs-datepicker";
import moment from 'moment/src/moment';

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      dt: "",
      start: {
        date: moment().add('week', '-1').toDate()
      },
      to: {
        date: moment().toDate()
      }
    }
  },
  computed: {
    companies() {
      return this.$store.getters.getCompanyCommission;
    },
    period() {
      return [this.start.date, this.to.date].join();
    }
  },
  watch: {
    period() {
      if (this.start.date && this.to.date) {
        this.fetch();
      }
    },
    companies() {
      if (this.dt) this.dt.destroy();
      setTimeout(() => {
        this.dt = $(this.$refs.tb_companies).DataTable({
          destroy: true,
          dom: 'Bfrtip',
          buttons: [{extend: 'csvHtml5', text: 'Excel'}]
        });
      }, 3000);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.dt = $(this.$refs.tb_companies).DataTable({
        dom: 'Bfrtip',
        buttons: [{extend: 'csvHtml5', text: 'Excel'}]
      });
    });
    this.getCompanyCommission();
  },
  methods: {
    getCompanyCommission() {
      if (!this.companies.length) {
        this.fetch();
      }
    },
    fetch() {
      this.$store.dispatch('fetchCompanyCommission', {start: this.start.date, end: this.to.date});
    },
    fullname(rm) {
      if (rm) {
        return rm.middlename ? rm.firstname + ' ' + rm.middlename + ' ' + rm.lastname : rm.firstname + ' ' + rm.lastname;
      } else {
        return "None";
      }
    }
  }
}
</script>
